import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "options" }
const _hoisted_2 = { class: "settings aux-pane" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-star" }, null, -1)
const _hoisted_4 = { class: "text-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash" }, null, -1)
const _hoisted_6 = { class: "text-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SurveyContainer = _resolveComponent("SurveyContainer")!
  const _component_Details = _resolveComponent("Details")!
  const _component_ResultsContainer = _resolveComponent("ResultsContainer")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["psychometric-widget widget", _ctx.wrapperClasses])
  }, [
    _withDirectives(_createElementVNode("i", {
      class: _normalizeClass(["pi fullscreen-toggle", _ctx.fullScreenIconClasses]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullScreenMode && _ctx.toggleFullScreenMode(...args)))
    }, null, 2), [
      [
        _directive_tooltip,
        _ctx.toggleTooltip,
        void 0,
        { left: true }
      ]
    ]),
    _createElementVNode("form", _hoisted_1, [
      (_ctx.enableModeSelector)
        ? (_openBlock(), _createBlock(_component_SelectButton, {
            key: 0,
            modelValue: _ctx.currentSurvey,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentSurvey) = $event)),
            options: _ctx.surveyOptions,
            optionLabel: "title",
            dataKey: "key",
            multiple: false,
            class: "survey-selector"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_component_SelectButton, {
        modelValue: _ctx.viewMode,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.viewMode) = $event)),
        options: _ctx.viewModes,
        multiple: false,
        optionLabel: "title",
        optionValue: "key",
        class: "mode-selector"
      }, {
        option: _withCtx((slotProps) => [
          _withDirectives(_createElementVNode("i", {
            class: _normalizeClass(["pi", slotProps.option.icon])
          }, null, 2), [
            [
              _directive_tooltip,
              slotProps.option.title,
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("form", _hoisted_2, [
      _createVNode(_component_Button, { onClick: _ctx.prefillAnswers }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.generateLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, { onClick: _ctx.resetData }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.resetLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_SurveyContainer, {
      onUpdate: _ctx.surveyUpdate,
      surveyKey: _ctx.currentSurveyKey,
      hasUser: _ctx.hasUserDetails,
      viewMode: _ctx.viewMode
    }, null, 8, ["onUpdate", "surveyKey", "hasUser", "viewMode"]),
    _createVNode(_component_Details, {
      currentAnswers: _ctx.currentAnswers,
      viewMode: _ctx.viewMode
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: "pi pi-cog settings-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enableSettings && _ctx.enableSettings(...args)))
        })
      ]),
      _: 1
    }, 8, ["currentAnswers", "viewMode"]),
    _createVNode(_component_ResultsContainer, {
      mode: _ctx.currentSurveyMode,
      viewMode: _ctx.viewMode
    }, null, 8, ["mode", "viewMode"])
  ], 2))
}